"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("./styles");
const defaultProps = {
  isDisabled: false,
  isChecked: false,
  onToggle: () => {},
  toggleWidth: 26,
  toggleHeight: 14,
  sliderRadius: 10
};
const Toggle = props => {
  const {
    onToggle,
    isChecked = false,
    isDisabled = false,
    toggleWidth = 26,
    toggleHeight = 14,
    sliderRadius = 10,
    toggleBg,
    toggleBgActive,
    dataAutomation = 'toggle'
  } = {
    ...defaultProps,
    ...props
  };
  const sliderOffset = toggleHeight / 2 - sliderRadius / 2;
  const sliderOnOffset = toggleWidth - sliderRadius - sliderOffset * 2;
  const onChange = e => {
    if (isDisabled) {
      return;
    }
    onToggle(e);
  };
  return (0, jsx_runtime_1.jsxs)(styles_1.Switch, {
    toggleWidth: toggleWidth,
    toggleHeight: toggleHeight,
    children: [(0, jsx_runtime_1.jsx)(styles_1.Input, {
      checked: isChecked,
      disabled: isDisabled,
      onChange: onChange
    }), (0, jsx_runtime_1.jsx)(styles_1.Slider, {
      toggleBg: toggleBg,
      toggleBgActive: toggleBgActive,
      isDisabled: isDisabled,
      sliderRadius: sliderRadius,
      sliderOffset: sliderOffset,
      sliderOnOffset: sliderOnOffset,
      "data-automation": dataAutomation
    })]
  });
};
exports.default = Toggle;